"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyAssetsInit = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var myPage_1 = require("../../model/myPage");
var service_1 = require("../../../library/base/service");
var MyAssetsInit = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(MyAssetsInit, _super);
    function MyAssetsInit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '我的资产';
        _this.code = '101157';
        _this.desc = '我的资产';
        _this.requestParams = new myPage_1.MyAssetsInitRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return MyAssetsInit;
}(service_1.BaseService));
exports.MyAssetsInit = MyAssetsInit;
//# sourceMappingURL=myAssetsInit.js.map